import { createContext } from "react";
export const ActualsContext = createContext({
  zoom: "month",
});
